import { useTranslation } from '@pancakeswap/localization'
import { Box, HelpIcon, Link, RocketIcon, Text, useMatchBreakpoints, useTooltip } from '@pancakeswap/uikit'
import ConnectWalletButton from '@/components/ConnectWalletButton'
import NextLink from 'next/link'
import { useTheme } from 'styled-components'
import { useAccount } from 'wagmi'
import { useBCakeBoostLimitAndLockInfo } from '../../hooks/bCakeV3/useBCakeV3Info'
import { Typography } from '@/components/ui/typography'
import { Button } from '@/components/ui/button'

export const useBCakeTooltipContent = () => {
  const { t } = useTranslation()
  const tooltipContent = (
    <>
      <Box mb="20px">
        {t(
          'Yield Boosters allow you to boost your farming yields by locking CAKE in the fixed-term staking CAKE pool. The more CAKE you lock, and the longer you lock them, the higher the boost you will receive.',
        )}
      </Box>
      <Box>
        {t('To learn more, check out the')}
        <Link target="_blank" href="https://medium.com/pancakeswap/introducing-bcake-farm-yield-boosters-b27b7a6f0f84">
          {t('Medium Article')}
        </Link>
      </Box>
    </>
  )
  return tooltipContent
}

export const BCakeBoosterCard = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { isMobile } = useMatchBreakpoints()

  const tooltipContent = useBCakeTooltipContent()

  const { targetRef, tooltip, tooltipVisible } = useTooltip(tooltipContent, {
    placement: 'bottom-start',
    ...(isMobile && { hideTimeout: 1500 }),
  })
  return (
    <div>
      <div className={'bg-card border p-6 rounded-2xl max-w-[460px] w-full'}>
        <div className={'flex gap-2 items-center mb-6'}>
          <RocketIcon className={'size-4'} />
          <Typography>{t('Yield Booster')}</Typography>
          {!tooltipVisible && tooltip}
          <Box ref={targetRef} style={{ float: 'right', position: 'relative', top: '6px' }}>
            <HelpIcon />
          </Box>
        </div>
        <CardContent />
      </div>
    </div>
  )
}

const CardContent: React.FC = () => {
  const { t } = useTranslation()
  const { address: account } = useAccount()
  const { locked } = useBCakeBoostLimitAndLockInfo()
  const theme = useTheme()

  if (!account)
    return (
      <Box>
        <Text color="textSubtle" fontSize={12} bold>
          {t('Connect wallet to view booster')}
        </Text>
        <Text color="textSubtle" fontSize={12} mb="16px">
          {t('An active veCAKE staking position is required for activating farm yield boosters.')}
        </Text>
        <ConnectWalletButton className={'w-full'} />
      </Box>
    )
  if (!locked)
    return (
      <div>
        <Typography variant={'tip'} className={'mb-2'}>
          {t('No FORGE locked')}
        </Typography>
        <Typography variant={'tip'} className={'mb-4'}>
          {t('An active veFORGE staking position is required for activating farm yield boosters.')}
        </Typography>
        <NextLink href="/lock">
          <Button className={'w-full'}>{t('Go to FORGE Staking')}</Button>
        </NextLink>
      </div>
    )

  return (
    <div>
      <Typography className={'mb-2'}>{t('Yield booster active')}</Typography>
      <Typography variant={'tip'} className={'mb-4'}>
        {t(
          'Boost unlimited number of positions on all V3 Farms. Boost will be applied when staking. Lock more CAKE or extend your lock to receive a higher boost.',
        )}
      </Typography>
      <NextLink href="/lock" passHref>
        <Button>{t('Go to Staking')}</Button>
      </NextLink>
    </div>
  )
}
